import React, { Component } from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import { styleMap, googleKey } from "../../config";
import ChangePath from "../ServiceApi";
const mapOptions = {
  mapTypeControl: false,
  streetViewControl: false,
  styles: styleMap,

  // map: themap,
  bounds: null,
  fillOpacity: 0.15,
  strokeWeight: 0.9,
  clickable: true
};
const MyMapComponent = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      defaultZoom={props.zoom}
      defaultCenter={props.center}
      options={mapOptions}
    >
      {props.data.map((item, index) => (
        item.location_lat === null || item.location_lon === null || item.location_lat === 0 || item.location_lon === 0  ? null : 
        <Marker
        key={index}
        position={{ lat: item.location_lat , lng: item.location_lon}}
        title={'The marker`s title will appear as a tooltip.'}
        icon={ChangePath.absoluteUrl("/icon/pin_job_status_" + item.priority_level + ".png")}
        onClick={() => props.triggerParentUpdate(item.job_id) 
        }
      />
      ))}
    </GoogleMap>

  ))
);
class Map extends Component {
  constructor(props) {
    super(props);
    //this.handlerItem = this.handlerItem.bind(this)
    //this.props = { handlerItem }
    //this.props = {action}
    this.state = {
      loading: false,
      visible: true,
      value: 1,
      bound: [],
      drawingMode: false,
      shapes: [],
    };
  }
  handleSelect() {
    console.log("handleSelect");
  }

  render() {
    return (
      <MyMapComponent
        zoom={this.props.zoom}
        center={this.props.center}
        data={this.props.data}
        isMarkerShown
        googleMapURL={
          "https://maps.googleapis.com/maps/api/js?key=" + googleKey
        }
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: "100%" }} />}
        mapElement={<div style={{ height: `100%` }} />}
        triggerParentUpdate={this.props.triggerParentUpdate}
      />
    );
  }
}

export default Map;
